import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Box, Button, MenuItem, Select } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useTranslation } from 'react-i18next';
import SearchBar from 'src/components/SearchBar';
import DownloadButton from 'src/components/DownloadButton';
import Filter from 'src/components/Filter/Filter';
import FILTER_TYPES from 'src/utils/constants/filter';
import { PaymentOriginChannel } from 'src/utils/constants/transactions';
import useStyles from './styles';

const dateRangeFilters = [
  {
    title: 'TRANSACTION.PAYMENT_DATE_COLUMN',
    controlGroup: FILTER_TYPES.DATE_IN_RANGE,
    items: [
      {
        label: 'COMMON.START_DATE',
        value: 'afterDate',
        view: ['year', 'month', 'day']
      },
      {
        label: 'COMMON.END_DATE',
        value: 'beforeDate',
        view: ['year', 'month', 'day']
      }
    ]
  }
];

const GlobalPaymentsToolbar = ({
  search,
  onSearchChange,
  originChannel,
  onOriginChannelChange,
  dateRange,
  onDateRangeChange,
  onClear,
  onDownload
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <Box className={classes.toolbar}>
      <Box className={classes.toolbarLeft}>
        <SearchBar
          searchValue={search}
          handleSearch={(event) => onSearchChange(event.target.value)}
          placeholder={t('TRANSACTION.SEARCH_PAYMENTS_PLACEHOLDER')}
          sx={{ ml: 0, width: 320 }}
        />
        <Select
          className={classes.select}
          value={originChannel}
          onChange={(event) => onOriginChannelChange(event.target.value)}
          displayEmpty
        >
          <MenuItem value="">{t('TRANSACTION.ALL_ORIGINS')}</MenuItem>
          {Object.values(PaymentOriginChannel).map((channel) => (
            <MenuItem key={channel} value={channel}>
              {t(`TRANSACTION.PAYMENT_ORIGIN.${channel}`)}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box className={classes.toolbarRight}>
        <Button
          className={clsx(classes.buttons, classes.outlined)}
          color="primary"
          startIcon={<FilterListIcon className={classes.icon} />}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          {t('COMMON.FILTER')}
        </Button>
        <Button
          className={clsx(classes.buttons, classes.outlined)}
          color="primary"
          onClick={onClear}
        >
          {t('COMMON.CLEAR_FILTERS')}
        </Button>
        <DownloadButton onDownload={onDownload} title="COMMON.DOWNLOAD_EXCEL" />
        <Filter
          anchorEl={anchorEl}
          filterValues={dateRange}
          handleClose={() => setAnchorEl(null)}
          handleChange={onDateRangeChange}
          filters={dateRangeFilters}
          allowManualInput
        />
      </Box>
    </Box>
  );
};

GlobalPaymentsToolbar.propTypes = {
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  originChannel: PropTypes.string.isRequired,
  onOriginChannelChange: PropTypes.func.isRequired,
  dateRange: PropTypes.object.isRequired,
  onDateRangeChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired
};

export default GlobalPaymentsToolbar;
